import * as React from "react";
import {PropsWithChildren, ReactNode, useEffect, useMemo, useRef} from "react";
import {stylesheet} from "typestyle";
import {classNames, useClickAway, useIdle} from "@variocube/cube-ui";

export interface AwesomeBarDropdownProps {
    button?: ReactNode;
    alignContent: "left" | "right";
    position?: "above" | "below";
    open: boolean;
    onClose: () => void;
}

export function AwesomeBarDropdown(props: PropsWithChildren<AwesomeBarDropdownProps>) {
    const {
        button,
        alignContent,
        position = "below",
        children,
        open,
        onClose
    } = props;
    const content = useRef<HTMLDivElement>(null);
    useClickAway(content.current, onClose);

    const idle = useIdle(30);
    useEffect(() => {
        if (idle) {
            onClose();
        }
    }, [idle, onClose]);

    const alignClass = useMemo(() => {
        switch (alignContent) {
            case "left": return styles.contentLeft;
            case "right": return styles.contentRight;
        }
    }, [alignContent]);

    return (
        <div className={styles.dropdown}>
            <div className={classNames(styles.button, open && styles.buttonOpen)}>
                {button}
            </div>
            <div
                className={classNames(
                    styles.content,
                    alignClass,
                    position == "below" ? styles.contentBelow : styles.contentAbove,
                    open && styles.contentOpen
                )}
                ref={content}
            >
                {children}
            </div>
        </div>
    );
}

const styles = stylesheet({
    dropdown: {
        position: "relative",
    },
    button: {
        height: "100%"
    },
    buttonOpen: {
        background: "#222"
    },
    content: {
        position: "absolute",
        display: "none",
        minWidth: "100%",
    },
    contentAbove: {
        bottom: "100%",
    },
    contentBelow: {
        top: "100%",
    },
    contentOpen: {
        display: "block"
    },
    contentLeft: {
        left: 0,
    },
    contentRight: {
        right: 0,
    },
});